var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCarteiraHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    fillOpacity: 0.01,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 12.75H16.5V14.25H18V12.75Z",
    fill: "#0092C6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 6H3V3.75H19.5V2.25H3C2.60218 2.25 2.22064 2.40804 1.93934 2.68934C1.65804 2.97064 1.5 3.35218 1.5 3.75V19.5C1.5 19.8978 1.65804 20.2794 1.93934 20.5607C2.22064 20.842 2.60218 21 3 21H21C21.3978 21 21.7794 20.842 22.0607 20.5607C22.342 20.2794 22.5 19.8978 22.5 19.5V7.5C22.5 7.10218 22.342 6.72064 22.0607 6.43934C21.7794 6.15804 21.3978 6 21 6ZM3 19.5V7.5H21V9.75H15C14.6022 9.75 14.2206 9.90804 13.9393 10.1893C13.658 10.4706 13.5 10.8522 13.5 11.25V15.75C13.5 16.1478 13.658 16.5294 13.9393 16.8107C14.2206 17.092 14.6022 17.25 15 17.25H21V19.5H3ZM21 11.25V15.75H15V11.25H21Z",
    fill: "#0092C6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarteiraHome);
export default __webpack_public_path__ + "static/media/carteiraHome.4e4477a9438db12cacc3072d87fc51ac.svg";
export { ForwardRef as ReactComponent };